var _path, _path2, _path3, _path4, _path5, _path6, _path7, _linearGradient, _path8, _linearGradient2, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M22.5 21h-21A1.5 1.5 0 0 1 0 19.5v-15A1.5 1.5 0 0 1 1.5 3h21A1.5 1.5 0 0 1 24 4.5v15a1.5 1.5 0 0 1-1.5 1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D54C3F",
    d: "M3 21H1.5A1.5 1.5 0 0 1 0 19.5v-15a1.5 1.5 0 0 1 3 0V21z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B63524",
    d: "M21 21h1.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-3 0V21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE5145",
    d: "M23.359 5.73a1.5 1.5 0 0 0-1.718-2.46l-9.64 7.018h-.002L2.359 3.27A1.501 1.501 0 0 0 .641 5.73l-.04-.029L12 14l11.359-8.27zm.04-.029L12 14l11.399-8.299z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M22.5 3c-.319 0-.616.1-.859.27l-9.64 7.018h-.002L2.359 3.27A1.496 1.496 0 0 0 1.5 3h21z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C64132",
    d: "M3.001 8.094.473 5.59l-.001.002c.053.05.109.096.169.138l-.04-.029 2.4 1.747v.664-.018z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M10.334 15.296 3 21l.001-12.968 7.332 7.262.001.002z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -261.914,
    x2: -261.679,
    y1: 1097.147,
    y2: 1097.147,
    gradientTransform: "matrix(38.2761 0 0 -38.2761 10028.054 42005.938)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdcd"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M10.334 15.296 12 14 3.001 7.448v.583l7.332 7.262.001.003z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -261.722,
    x2: -261.444,
    y1: 1097.073,
    y2: 1097.073,
    gradientTransform: "matrix(38.2761 0 0 -38.2761 10028.054 42005.938)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e2e2"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M16.03 21H21V7.448L12 14l-1.667 1.293L16.03 21z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.137e4010d94a696dd4d8ee44e53176ea.svg";
export { ForwardRef as ReactComponent };